'use client';

import React from 'react';
import onTabChange from './onTabChange';
import { TAB_META } from '~/consts/tab';
import { TabConfig } from '~/definitions/tab';
import { getStore } from '~/mobx/AppStore';
import Admin from '~/components/Tabs/Admin';
import AdminReport from '~/components/Tabs/AdminReport';
import Preview from '~/components/Tabs/Preview';
import GeneralSettings from '~/components/Tabs/GeneralSettings';
import Candidates from '~/components/Tabs/Candidates';
import ZipCodes from '~/components/Tabs/ZipCodes';
import Reports from '~/components/Tabs/Reports';
import StandAdmin from '~/components/Tabs/StandAdmin';

const getTabs = () => {
    const { tabStore, electionMenuStore, userStore } = getStore();
    const activeTabId = tabStore.activeTabId;
    const isDisabledForSlag = !electionMenuStore.selectedElectionMenu || electionMenuStore.isCompanyLevel;
    const isSuperAdmin = userStore.getIsSuperAdmin();
    const isSlagAdmin = userStore.getIsSlagAdmin();
    const isStandAdmin = userStore.getIsStandAdmin();

    const tabs: TabConfig[] = [
        isSuperAdmin && {
            id: TAB_META.ADMIN.id,
            name: TAB_META.ADMIN.name,
            isActive: activeTabId === TAB_META.ADMIN.id,
            onClick: () => onTabChange(TAB_META.ADMIN.id),
            content: activeTabId === TAB_META.ADMIN.id && <Admin />,
        },
        isSuperAdmin && {
            id: TAB_META.ADMIN_REPORT.id,
            name: TAB_META.ADMIN_REPORT.name,
            isActive: activeTabId === TAB_META.ADMIN_REPORT.id,
            onClick: () => onTabChange(TAB_META.ADMIN_REPORT.id),
            content: activeTabId === TAB_META.ADMIN_REPORT.id && <AdminReport />,
        },
        (isSuperAdmin || isSlagAdmin) && {
            id: TAB_META.GENERAL_SETTINGS.id,
            name: TAB_META.GENERAL_SETTINGS.name,
            isActive: activeTabId === TAB_META.GENERAL_SETTINGS.id,
            onClick: () => onTabChange(TAB_META.GENERAL_SETTINGS.id),
            content: activeTabId === TAB_META.GENERAL_SETTINGS.id && <GeneralSettings />,
        },
        (isSuperAdmin || isSlagAdmin) && {
            id: TAB_META.CANDIDATES.id,
            name: TAB_META.CANDIDATES.name,
            isActive: activeTabId === TAB_META.CANDIDATES.id,
            isDisabled: isDisabledForSlag,
            onClick: () => onTabChange(TAB_META.CANDIDATES.id),
            content: activeTabId === TAB_META.CANDIDATES.id && <Candidates />,
        },
        (isSuperAdmin || isSlagAdmin) && {
            id: TAB_META.POSTAL_CODE.id,
            name: TAB_META.POSTAL_CODE.name,
            isActive: activeTabId === TAB_META.POSTAL_CODE.id,
            isDisabled: isDisabledForSlag,
            onClick: () => onTabChange(TAB_META.POSTAL_CODE.id),
            content: activeTabId === TAB_META.POSTAL_CODE.id && <ZipCodes />,
        },
        (isSuperAdmin || isSlagAdmin) && {
            id: TAB_META.PREVIEW.id,
            name: TAB_META.PREVIEW.name,
            isActive: activeTabId === TAB_META.PREVIEW.id,
            onClick: () => onTabChange(TAB_META.PREVIEW.id),
            content: activeTabId === TAB_META.PREVIEW.id && <Preview />,
        },
        isStandAdmin && {
            id: TAB_META.STAND_ADMIN.id,
            name: TAB_META.STAND_ADMIN.name,
            isActive: activeTabId === TAB_META.STAND_ADMIN.id,
            onClick: () => onTabChange(TAB_META.STAND_ADMIN.id),
            content: activeTabId === TAB_META.STAND_ADMIN.id && <StandAdmin />,
        },
        (isSuperAdmin || isSlagAdmin) && {
            id: TAB_META.REPORT.id,
            name: TAB_META.REPORT.name,
            isActive: activeTabId === TAB_META.REPORT.id,
            onClick: () => onTabChange(TAB_META.REPORT.id),
            content: activeTabId === TAB_META.REPORT.id && <Reports />,
        },
    ].filter(Boolean) as TabConfig[];

    return userStore.isInitialized ? tabs : [];
};

export default getTabs;
